import styled from 'styled-components';
import {
  Row,
  Label,
  Input,
  FormFeedback as FormFeedbackBootstrap,
  Button as ButtonBootstrap,
} from 'reactstrap';
import colors from '../../includes/colors';

export const PageContainer = styled(Row)`
  width: 720px;
  margin: 0 auto;
  flex-flow: column;
`;

export const FormFeedback = styled(FormFeedbackBootstrap)`
  height: 10px;
  display: block;
`;

export const FormLabel = styled(Label)`
  color: ${colors.strongGray};
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  font-weight: 500;
`;

export const QuestionMark = styled.span`
  fill: ${colors.blue};
  margin-left: 4px;

  :hover, :focus {
    fill: ${colors.darkBlue};
  }

  svg {
    width: 20px;
    height: 20px;
    margin-bottom: 4px;
  }
`;

export const CheckIcon = styled.span`
  color: ${colors.green};
  font-size: 1.2rem;
`;

export const ErrorIcon = styled.span`
  color: red;
  font-size: 1.2rem;
`;

export const TickIcon = styled.span`
  color: ${colors.green};
  font-size: 1.2rem;
`;

export const AlertContent = styled.div`
  display: flex;
`;

export const AlertText = styled.div`
  margin-left: 0.5rem;
`;

export const Description = styled.p``;

export const Link = styled.div``;

export const Actions = styled.div`
  margin-bottom: 1rem;
`;

export const Button = styled(ButtonBootstrap)`
  min-width: 126px;
  background-color: ${ colors.blue };
  border: none;

  &:active, &:focus {
    background-color: ${ colors.darkBlue } !important;
    box-shadow: none;
    border: 2px solid black;
  }

  &:hover:enabled {
    background-color: ${ colors.darkBlue };
  }

  &:disabled {
    opacity: 1;
    cursor: initial;
  }
`;

export const AlertPopup = styled.div`
`;

export const FormSpan = styled.span`
  height: 10px;
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;

  &.active {
    display: none;
  }
`

export const CharacterCounter = styled.div`
  float: right;
`;

export const CharacterLimitAlert = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
`;

export const MessageInput = styled(Input)`
  &.invalidCharacters {
    border-color: #dc3545;
  }
`;
